// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
::after,
::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar-track {
  background-color: white;
}

::-webkit-scrollbar {
  width: 5px;
  background: #b8b7b7;
}

::-webkit-scrollbar-thumb {
  width: 5px;
  background: #b8b7b7;
}

:root {
  /* Cores Azuis */
  --blue-90: #e7eefa;
  --blue-80: #cfddf5;
  --blue-70: #b7cdf0;
  --blue-60: #9fbceb;
  --blue-50: #87abe6;
  --blue-40: #6f9ae1;
  --blue-30: #5789dc;
  --blue-20: #3f79d7;
  --blue-10: #2768d2;
  --blue-base: #0f57cd;
  --blue-shade-10: #0e4eb9;
  --blue-shade-20: #0c46a4;
  --blue-shade-30: #0b3d90;
  --blue-shade-40: #09347b;
  --blue-shade-50: #082c67;
  --blue-shade-60: #062352;
  --blue-shade-70: #051a3e;
  --blue-shade-80: #031129;
  --blue-shade-90: #010914;
  /* Cores Cinzas */
  --gray-90: #f7f7f7;
  --gray-80: #e5e5e5;
  --gray-70: #d4d4d4;
  --gray-60: #c2c2c2;
  --gray-50: #b0b0b0;
  --gray-40: #9e9e9e;
  --gray-30: #8d8d8d;
  --gray-20: #7b7b7b;
  --gray-10: #696969;
  --gray-base: #575757;
  --gray-shade-10: #464646;
  --gray-shade-20: #343434;
  --gray-shade-30: #222222;
  --gray-shade-40: #111111;
  /* Cores de Status */
  --success: #4caf50;
  --error: #e4684b;
  --warning: #ff9800;
  /* Preto e Branco */
  --black: #000000;
  --white: #ffffff;
  /* Botão Verde */
  --green-button: #4caf50;
  --green-button-hover: #388e3c;
  /* Botão Cinza */
  --gray-button: #9e9e9e;
  --gray-button-hover: #757575;
  --color-input-border: #b7b7b7;
  --color-input-shadow: 0px 0px 0px 0.15px #b7b7b7;
  --color-input-placeholder: #d2d2d2;
}

html {
  font-size: 100%;
}

body {
  background-color: #f1f1f1 !important;
  color: #555555 !important;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.75;
}

p {
  margin-bottom: 1.5rem;
  max-width: 40em;
}

button {
  cursor: pointer;
}

a {
  color: inherit;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
  font-weight: 400;
  line-height: 1.3;
}

h1 {
  margin-top: 0;
  font-size: 2.052rem;
  font-weight: bold;
}

h2 {
  font-size: 1.641rem;
  font-weight: bold;
}

h3 {
  font-size: 1.153rem;
  font-weight: bold;
}

h4 {
  font-size: 0.9rem;
  font-weight: bold;
}

h5 {
  font-size: 0.8rem;
  font-weight: bold;
}

label {
  font-size: 12px !important;
}

input {
  font-size: 12px !important;
}

select {
  font-size: 12px !important;
  text-align: left !important;
}

option {
  font-size: 12px !important;
}

button {
  font-size: 12px !important;
}

.contenteLayoutCollapsed {
  margin-top: 70px;
  position: relative;
  min-width: 100%;
  padding-left: 110px;
  padding-right: 15px;
  transition: all 0.2s ease-in-out;
}

.contenteLayout {
  margin-top: 70px;
  position: relative;
  min-width: 100%;
  padding-left: 285px;
  padding-right: 15px;
  transition: all 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/globalStyles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;EAGE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,UAAA;EACA,mBAAA;AAGF;;AADA;EACE,UAAA;EACA,mBAAA;AAIF;;AADA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,sBAAA;EACA,4BAAA;EAEA,6BAAA;EACA,gDAAA;EACA,kCAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;;;;;EAKE,SAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAHF","sourcesContent":["*,\n::after,\n::before {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #ffff;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  background: #b8b7b7;\n}\n::-webkit-scrollbar-thumb {\n  width: 5px;\n  background: #b8b7b7;\n}\n\n:root {\n  /* Cores Azuis */\n  --blue-90: #e7eefa;\n  --blue-80: #cfddf5;\n  --blue-70: #b7cdf0;\n  --blue-60: #9fbceb;\n  --blue-50: #87abe6;\n  --blue-40: #6f9ae1;\n  --blue-30: #5789dc;\n  --blue-20: #3f79d7;\n  --blue-10: #2768d2;\n  --blue-base: #0f57cd;\n  --blue-shade-10: #0e4eb9;\n  --blue-shade-20: #0c46a4;\n  --blue-shade-30: #0b3d90;\n  --blue-shade-40: #09347b;\n  --blue-shade-50: #082c67;\n  --blue-shade-60: #062352;\n  --blue-shade-70: #051a3e;\n  --blue-shade-80: #031129;\n  --blue-shade-90: #010914;\n\n  /* Cores Cinzas */\n  --gray-90: #f7f7f7;\n  --gray-80: #e5e5e5;\n  --gray-70: #d4d4d4;\n  --gray-60: #c2c2c2;\n  --gray-50: #b0b0b0;\n  --gray-40: #9e9e9e;\n  --gray-30: #8d8d8d;\n  --gray-20: #7b7b7b;\n  --gray-10: #696969;\n  --gray-base: #575757;\n  --gray-shade-10: #464646;\n  --gray-shade-20: #343434;\n  --gray-shade-30: #222222;\n  --gray-shade-40: #111111;\n\n  /* Cores de Status */\n  --success: #4caf50;\n  --error: #e4684b;\n  --warning: #ff9800;\n\n  /* Preto e Branco */\n  --black: #000000;\n  --white: #ffffff;\n\n  /* Botão Verde */\n  --green-button: #4caf50;\n  --green-button-hover: #388e3c;\n\n  /* Botão Cinza */\n  --gray-button: #9e9e9e;\n  --gray-button-hover: #757575;\n\n  --color-input-border: #b7b7b7;\n  --color-input-shadow: 0px 0px 0px 0.15px #b7b7b7;\n  --color-input-placeholder: #d2d2d2;\n}\n\nhtml {\n  font-size: 100%;\n}\n\nbody {\n  background-color: #f1f1f1 !important;\n  color: #555555 !important;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  line-height: 1.75;\n}\n\np {\n  margin-bottom: 1.5rem;\n  max-width: 40em;\n}\n\nbutton {\n  cursor: pointer;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  margin: 0;\n  font-weight: 400;\n  line-height: 1.3;\n  //text-transform: capitalize;\n}\n\nh1 {\n  margin-top: 0;\n  font-size: 2.052rem;\n  font-weight: bold;\n}\n\nh2 {\n  font-size: 1.641rem;\n  font-weight: bold;\n}\n\nh3 {\n  font-size: 1.153rem;\n  font-weight: bold;\n}\n\nh4 {\n  font-size: 0.9rem;\n  font-weight: bold;\n}\n\nh5 {\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\nlabel {\n  font-size: 12px !important;\n}\n\ninput {\n  font-size: 12px !important;\n}\n\nselect {\n  font-size: 12px !important;\n  text-align: left !important;\n}\n\noption {\n  font-size: 12px !important;\n}\n\nbutton {\n  font-size: 12px !important;\n}\n\n.contenteLayoutCollapsed {\n  margin-top: 70px;\n  position: relative;\n  min-width: 100%;\n  padding-left: 110px;\n  padding-right: 15px;\n  transition: all 0.2s ease-in-out;\n}\n\n.contenteLayout {\n  margin-top: 70px;\n  position: relative;\n  min-width: 100%;\n  padding-left: 285px;\n  padding-right: 15px;\n  transition: all 0.2s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
